import * as VueRouter from 'vue-router';

// Layout Pages
const PageView = () => import('./Views/PageView/PageView.vue');
const NewsListView = () => import('./Views/NewsListView/NewsListView.vue');
const NewsPageView = () => import('./Views/NewsPageView/NewsPageView.vue');
const BlogListView = () => import('./Views/BlogListView/BlogListView.vue');
const BlogPageView = () => import('./Views/BlogPageView/BlogPageView.vue');
const ToolCategoriesPageView = () => import('./Views/ToolCategoryView/ToolCategoryView.vue');

const routes = [
	{
		path: '/',
		name: 'home',
		component: PageView,
	},
	{
		path: '/:permalink',
		name: 'page-view',
		alias: ['/landing/:permalink', '/page/:permalink'],
		component: PageView,
	},
	{
		path: '/news',
		name: 'news',
		component: NewsListView,
	},
	{
		path: '/news/:slug',
		name: 'news-detail',
		component: NewsPageView,
	},
	{
		path: '/blogs',
		name: 'blog',
		component: BlogListView,
	},
	{
		path: '/blogs/:slug',
		name: 'blog-detail',
		component: BlogPageView,
	},
	{
		path: '/tool-categories',
		name: 'tool-categories',
		alias: ['/tool-categories/:id'],
		component: ToolCategoriesPageView,
	},


	{path: '/:pathMatch(.*)*', name: '404', redirect: '/'},
];

const router = VueRouter.createRouter({
	history: VueRouter.createWebHistory(),
	routes,
});

router.beforeEach(async (to, from, next) => {
	// const store = useAuthStore();
	//
	// if ((to.name !== 'login' && to.name !== 'register') && !store.isLoggedIn) {
	// 	next({name: "login"});
	// } else if ((to.name === 'login' || to.name === 'register') && store.isLoggedIn) {
	// 	next({name: 'dashboard'});
	// } else if (store.isLoggedIn === false && to.meta.auth === true) {
	// 	await Sweetalert2.fire({
	// 		title: 'Kérlek jelentkezz be az oldal megtekintéséhez!',
	// 		icon: 'warning',
	// 		confirmButtonColor: 'var(--colorMain)',
	// 		confirmButtonText: 'OK'
	// 	});
	// 	await router.push({name: 'home'});
	// 	return;
	// }
	// // Otherwise allowed viewing..
	// if (store.isLoggedIn && !store.isLoaded) {
	// 	await store.getMe();
	// }
	next();
});

export default router;
